"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return NcHelp;
    }
});
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _pqueue = /*#__PURE__*/ _interop_require_default(require("p-queue"));
const _common = require("@nestjs/common");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const NC_EXECUTE_OPERATIONS_CONCURRENCY = parseInt(process.env.NC_EXECUTE_OPERATIONS_CONCURRENCY) || 5;
let NcHelp = class NcHelp {
    static async executeOperations(fns, dbType) {
        const queue = new _pqueue.default({
            concurrency: dbType === 'oracledb' ? 1 : NC_EXECUTE_OPERATIONS_CONCURRENCY
        });
        const errors = [];
        for (const fn of fns){
            queue.add(async ()=>{
                if (errors.length) {
                    return;
                }
                try {
                    await fn();
                } catch (e) {
                    this.logger.error(e);
                    errors.push(e);
                }
            });
        }
        await queue.onIdle();
        if (errors.length) {
            throw errors[0];
        }
    }
    static enableOrDisableDebugLog(args) {
        const enabledKeys = _debug.default.disable().split(',').filter((v)=>v.trim());
        for (const [key, enabled] of Object.entries(args)){
            if (enabled) {
                if (!enabledKeys.includes(key)) {
                    enabledKeys.push(key);
                }
            } else {
                const index = enabledKeys.indexOf(key);
                if (index > -1) {
                    enabledKeys.splice(index, 1);
                }
            }
        }
        _debug.default.enable(enabledKeys.join(','));
    }
};
NcHelp.logger = new _common.Logger('NcHelp');
